import type { Move } from '@draughts/shared';

/**
 * Pair moves into rows: [whiteMove, blackMove?].
 *
 * Una copia sola per le TRE liste che la usano — `MoveList` (partita online),
 * `LocalMoveList` (locale/hot-seat) e `ReplayMoveList` (revisione). Erano due
 * copie identiche, e la terza avrebbe reso la divergenza una questione di tempo.
 */
export function pairMoves(moves: Move[]): [Move, Move | undefined][] {
  const pairs: [Move, Move | undefined][] = [];
  for (let i = 0; i < moves.length; i += 2) {
    const white = moves[i];
    if (white) pairs.push([white, moves[i + 1]]);
  }
  return pairs;
}
